import { Suspense, lazy, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./home.css";
import HomeShell from "./HomeShell";
import Hero from "./Hero";
import { TrustBar } from "./Showcase";

// Below-the-fold sections load after the hero is on screen — the first paint is nav + hero only.
const Problem = lazy(() => import("./Problem"));
const Connected = lazy(() => import("./Connected"));
const Intelligence = lazy(() => import("./Intelligence"));
const AiWorking = lazy(() => import("./AiWorking"));
const StaffPortal = lazy(() => import("./StaffPortal"));
const ClockIn = lazy(() => import("./ClockIn"));
const ClientPortal = lazy(() => import("./ClientPortal"));
const SupplySection = lazy(() => import("./SupplySection"));
const BeforeAfter = lazy(() => import("./BeforeAfter"));
const Profitability = lazy(() => import("./Profitability"));
const Owner = lazy(() => import("./OwnerRoles").then((m) => ({ default: m.Owner })));
const ProjectsSection = lazy(() => import("./Story").then((m) => ({ default: m.ProjectsSection })));
const DayInLife = lazy(() => import("./Story").then((m) => ({ default: m.DayInLife })));
const FourSides = lazy(() => import("./Story").then((m) => ({ default: m.FourSides })));
const Trades = lazy(() => import("./TradesPlatform").then((m) => ({ default: m.Trades })));
const Final = lazy(() => import("./FinalCta").then((m) => ({ default: m.FinalCta })));
const SocialProof = lazy(() => import("./FinalCta").then((m) => ({ default: m.SocialProof })));

const DESCRIPTION = "TRAIDE is the AI Operating System for Trade Businesses. Customers, staff, jobs, quotes, materials, suppliers and finances — connected in one intelligent platform.";
const Fallback = () => <div className="hp-wrap py-24" aria-hidden><div className="h-6 w-56 rounded bg-white/[.05]" /></div>;

// Public homepage — the trade owner's story, then the operating system that runs the business around them.
export default function HomePage() {
  const { hash } = useLocation();
  useEffect(() => {
    document.title = "TRAIDE — The AI Operating System for Trade Businesses";
    document.querySelector('meta[name="description"]')?.setAttribute("content", DESCRIPTION);
    if (!hash) { window.scrollTo(0, 0); return; }
    let n = 0;
    const t = setInterval(() => { const el = document.getElementById(hash.slice(1)); if (el || ++n > 20) { clearInterval(t); el?.scrollIntoView({ behavior: "smooth", block: "start" }); } }, 150);
    return () => clearInterval(t);
  }, [hash]);
  return (
    <HomeShell>
      <Hero />
      <TrustBar />
      <Suspense fallback={<Fallback />}>
        <Problem />
        <Connected />
        <Intelligence />
        <AiWorking />
        <Owner />
        <StaffPortal />
        <ClockIn />
        <ClientPortal />
        <ProjectsSection />
        <SupplySection />
        <Profitability />
        <BeforeAfter />
        <DayInLife />
        <FourSides />
        <Trades />
        <SocialProof />
        <Final />
      </Suspense>
    </HomeShell>
  );
}
